import { render, staticRenderFns } from "./assign.vue?vue&type=template&id=154f8888&scoped=true"
import script from "./assign.vue?vue&type=script&lang=js"
export * from "./assign.vue?vue&type=script&lang=js"
import style0 from "./assign.vue?vue&type=style&index=0&id=154f8888&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154f8888",
  null
  
)

export default component.exports